import React from "react"
import Card from '../components/Card'

export default function Home() {
    function titles() {
        let titles = ["pattern","color","shape","gradient","background","material"]
        return titles.map((title,i) => {
            return <Card key={i} title={title} />
        })
    }
    return (
        <div className ="home">
            <div className="center">
                <h1 className="bigtitle">Make great work happen from anywhere. </h1>
                <p className="description smalltitle">Get started creating and gathering design elements for projects, clients or teams with these quick actions. Add them to Creative Cloud Libraries to work smarter.</p>
            </div>
            <div className="grid">
                {titles()}
            </div>
        </div>
    )
}